import React from 'react';
import { FormDialog } from '../../../form-dialog/form-dialog';
import { MultiSelect } from '../../../multi-select/multi-select';
import { Checkbox } from '../../../checkbox/checkbox';
import { Row } from '../../../row/row';
import { Cell } from '../../../cell/cell';
import { EducatorDto } from '../../../../api-service/clients/auto-generated-clients';

export interface IFutureLessonsOption {
  label: string;
  description: string;
  checked: boolean;
  onToggle: () => void;
}

export interface IChangeCourseEducatorsDialogComponentProps {
  title: string;
  description: string;
  educators: EducatorDto[];
  educatorIdsToAdd: string[];
  educatorIdsToRemove: string[];
  futureLessonsOption?: IFutureLessonsOption;
  isLoadingEducators: boolean;
  isSaving: boolean;
  onEducatorsToAddChange: (educators: EducatorDto[]) => void;
  onEducatorsToRemoveChange: (educators: EducatorDto[]) => void;
  onConfirm: () => void;
  onClose: () => void;
}

function renderEducatorOption(optionProps: React.HTMLAttributes<HTMLLIElement>, educator: EducatorDto) {
  return (
    <li {...optionProps} key={educator.educatorId}>
      {educator.name}
    </li>
  );
}

export function ChangeCourseEducatorsDialogComponent({
  title,
  description,
  educators,
  educatorIdsToAdd,
  educatorIdsToRemove,
  futureLessonsOption,
  isLoadingEducators,
  isSaving,
  onEducatorsToAddChange,
  onEducatorsToRemoveChange,
  onConfirm,
  onClose,
}: IChangeCourseEducatorsDialogComponentProps) {
  const isValid = educatorIdsToAdd.length > 0 || educatorIdsToRemove.length > 0;

  return (
    <FormDialog
      open
      title={title}
      confirmButtonText="Udfør"
      cancelButtonText="Afbryd"
      isLoading={isSaving}
      isValid={isValid && !isLoadingEducators}
      onConfirmClick={onConfirm}
      onCancelClick={onClose}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <p>{description}</p>
      <Row>
        <Cell size="full">
          <MultiSelect<EducatorDto>
            label="Tilføj"
            value={educators.filter(educator => educatorIdsToAdd.includes(educator.educatorId))}
            options={educators.filter(educator => !educatorIdsToRemove.includes(educator.educatorId))}
            getOptionLabel={educator => educator.name ?? ''}
            renderOption={renderEducatorOption}
            onChange={onEducatorsToAddChange}
            disabled={isLoadingEducators}
            variant="outlined"
          />
        </Cell>
        <Cell size="full">
          <MultiSelect<EducatorDto>
            label="Fjern"
            value={educators.filter(educator => educatorIdsToRemove.includes(educator.educatorId))}
            options={educators.filter(educator => !educatorIdsToAdd.includes(educator.educatorId))}
            getOptionLabel={educator => educator.name ?? ''}
            renderOption={renderEducatorOption}
            onChange={onEducatorsToRemoveChange}
            disabled={isLoadingEducators}
            variant="outlined"
          />
        </Cell>
        {futureLessonsOption && (
          <Cell size="full">
            <Checkbox checked={futureLessonsOption.checked} onChange={futureLessonsOption.onToggle} label={futureLessonsOption.label} />
            <p>{futureLessonsOption.description}</p>
          </Cell>
        )}
      </Row>
    </FormDialog>
  );
}
